import IndexModel from "@/service/v1/sigap/IndexModel";
 
class AulaDisciplinaService extends IndexModel { 
       
    constructor() {
        super();
        this.url =  this.url + '/AulaDisciplina' ;  
    }
 
    public getApiUrl(  ) { 
        return this.getAxios().defaults.baseURL + this.url; 
    }
 
    public getModel( id  ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().get( this.url + '/' + id    )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }
 
    // public cadastrarAulaControlador ( dados ) : Promise<any> { 
    //     return  new Promise((resolve, reject) => {
    //         this.getAxios().post( this.url + '/Controlador' , dados   )
    //         .then(response => {    
    //             resolve( response.data);  
    //         })
    //         .catch(error => {  
    //             reject(error.response);
    //         }) 
    //     }); 
    // }
 
    public updateCadastroAula( id , dados  ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().put( this.url + '/'  + id  + '/Controlador' ,   dados )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }
  
    
    public updateNumero( id: any , dados: any ) : Promise<any>  { 
        return  new Promise((resolve, reject) => {  
            this.getAxios().put( this.url + '/' + id + '/Numero'  , dados  )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {   
                reject(error.response);
            }) 
        }); 
    }
    

}
  
export default AulaDisciplinaService; 